import { render } from "./entryPostionCom.vue?vue&type=template&id=c88fb0e4&scoped=true"
import script from "./entryPostionCom.vue?vue&type=script&lang=js"
export * from "./entryPostionCom.vue?vue&type=script&lang=js"

import "@/assets/css/add.css?vue&type=style&index=0&id=c88fb0e4&scoped=true&lang=css&external"
import "./entryPostionCom.vue?vue&type=style&index=1&id=c88fb0e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c88fb0e4"]])

export default __exports__